(() => {
  const wbdText = (key, fallback) => window.variantStrings?.wbd?.[key] || fallback;
  let queue = Promise.resolve();
  let pending = 0;
  const route = (name) => window.routes?.[name] || '/cart';
  const request = async (url, config = {}) => {
    const response = await fetch(url, config);
    let data;
    try { data = await response.json(); }
    catch { throw new Error(window.cartStrings?.error || 'Winkelwagen kon niet worden bijgewerkt.'); }
    if (!response.ok || data.status || data.errors) {
      throw new Error(data.description || (typeof data.errors === 'string' ? data.errors : data.message) || window.cartStrings?.error || 'Winkelwagen kon niet worden bijgewerkt.');
    }
    return data;
  };
  const post = (url, body) => request(url, { ...fetchConfig(), body: JSON.stringify(body) });
  const get = () => request(`${route('cart_url')}.js`);
  const reconcileTool = async () => {
    const config = window.WBDFreeTool;
    if (!config?.enabled || !config.variantId) return false;
    const cart = await get();
    const truthy = (value) => String(value).toLowerCase() === 'true';
    const tools = cart.items.filter((item) => Number(item.variant_id) === Number(config.variantId));
    const automatic = tools.filter((item) => truthy(item.properties?._wbd_free_tool));
    const manual = tools.some((item) => !truthy(item.properties?._wbd_free_tool));
    const eligible = cart.items.some((item) => Number(item.variant_id) !== Number(config.variantId) && truthy(item.properties?._wbd_free_tool_eligible));
    let changed = false;
    for (let i = 0; i < automatic.length; i++) {
      const quantity = eligible && !manual && i === 0 ? 1 : 0;
      if (automatic[i].quantity !== quantity) {
        await post(`${route('cart_change_url')}.js`, { id: automatic[i].key, quantity });
        changed = true;
      }
    }
    if (eligible && !tools.length) {
      await post(`${route('cart_add_url')}.js`, { items: [{ id: config.variantId, quantity: 1, properties: { _wbd_free_tool: 'true' } }] });
      changed = true;
    }
    return changed;
  };
  const sections = async (ids) => {
    const url = new URL(route('cart_url'), location.origin);
    url.searchParams.set('sections', [...new Set(ids)].join(','));
    return request(url);
  };
  const finish = async (result, ids) => {
    let changed = false;
    try { changed = await reconcileTool(); }
    catch (error) {
      // A gift failure must never report the paid product as not added.
      result.wbdWarning = `${wbdText('gift_error', 'Je winkelwagen is bijgewerkt, maar de inkorttool kon niet worden gecontroleerd.')} ${error.message}`;
      changed = true;
    }
    if (changed) {
      try {
        const [cart, html] = await Promise.all([get(), sections(ids)]);
        return { ...result, ...cart, sections: html, wbdWarning: result.wbdWarning };
      } catch {
        result.sections = null;
        result.wbdWarning = wbdText('cart_updated', 'Je winkelwagen is bijgewerkt. Open je winkelwagen om de actuele inhoud te bekijken.');
      }
    }
    return result;
  };
  window.WBDCart = Object.freeze({
    get busy() { return pending > 0; },
    run(operation) {
      pending++;
      const next = queue.then(operation).finally(() => { pending--; });
      // Keep the queue usable; each caller still receives its own rejected promise.
      queue = next.catch(() => {});
      return next;
    },
    request, finish, get, sections
  });
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.WBDFreeTool?.enabled || !window.WBDFreeTool.variantId) return;
    const drawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');
    const entries = cartItems?.getSectionsToRender() || [];
    const ids = [...new Set(['cart-drawer', 'cart-icon-bubble', ...entries.map(entry => entry.section)])];
    window.WBDCart.run(async () => {
      const result = await finish(await get(), ids);
      if (result.sections) {
        drawer?.renderContents(result, { open: false });
        entries.forEach(entry => {
          const target = document.getElementById(entry.id)?.querySelector(entry.selector);
          const source = result.sections[entry.section] && new DOMParser().parseFromString(result.sections[entry.section], 'text/html').querySelector(entry.selector);
          if (target && source) target.innerHTML = source.innerHTML;
        });
      }
      if (result.wbdWarning) drawer?.showFeedback(result.wbdWarning, 'warning');
    }).catch(() => drawer?.showFeedback(wbdText('cart_error', 'Je winkelwagen kon niet worden gecontroleerd. Open de winkelwagen en probeer het opnieuw.')));
  }, { once: true });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[name="checkout"]')) return;
    if (pending) {
      event.preventDefault();
      document.querySelector('cart-drawer')?.showFeedback(wbdText('cart_busy', 'Je winkelwagen wordt bijgewerkt. Probeer het zo nogmaals.'), 'warning');
    } else {
      event.target.dispatchEvent(new CustomEvent('wbd:checkout_click', { bubbles: true }));
    }
  });
})();
